import LxcError from "~/core/models/LxcError.class";
import type { Sector } from "~/modules/sector/models/Sector.interface";
import sectorsService from "~/modules/sector/services/sectors.service";

export function useFetchSectors({
  organizationCode,
}: {
  organizationCode?: number;
}) {
  const isLoading: Ref<boolean> = ref(false);
  const error: Ref<LxcError | undefined> = ref();
  const sectors: Ref<Sector[]> = ref([]);

  async function getSectors(searchParams?: string) {
    isLoading.value = true;
    error.value = undefined;

    if (organizationCode) {
      const response = await sectorsService.getSectors({
        organizationCode,
        searchParams,
      });

      if (LxcError.check(response)) {
        error.value = response;
      } else {
        sectors.value = [response];
      }
    } else {
      throw new Error("Organization code is undefined");
    }

    isLoading.value = false;
  }

  return {
    isLoading,
    error,
    sectors,
    getSectors,
  };
}
